var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"folder-caret append-right-4"},[_c('icon',{attrs:{"size":10,"name":_vm.iconClass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }